const root = 'storeLocationForm'

export const TestId = {
  root,
  cardHeader: `${root}-cardHeader`,
  countrySelect: `${root}-countrySelect`,
  submitButton: `${root}-submitButton`,
  discardButton: `${root}-discardButton`,
}
